import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { fromEvent } from 'rxjs';

@Component({
  selector: 'i-dream-cam',
  templateUrl: './i-dream-cam.component.html',
  styleUrls: ['./i-dream-cam.component.scss']
})
export class IDreamCamComponent implements OnInit {

  @Input() retryObservable: Subject<void>;
  @Input() snapshotObservable: Subject<void>;
  @Output() snapshotEvent = new EventEmitter();
  @Output() cameraErrorEvent = new EventEmitter();

  @ViewChild("videoPlayer") videoPlayer: ElementRef;
  @ViewChild("outputImage") outputImage: ElementRef;

  imageHeight = 0;
  currentStream = null;
  cameraError = false;
  loading = true;

  availableDevices = [];
  currentDevice = -1;
  adjustImageHeight = true;

  constructor() { }

  public ngOnInit() {

    this.snapshotObservable.subscribe(() => {
      this.takeSnapshot();
    });

    this.retryObservable.subscribe(() => {
      this.shrinkImage();
    });

    navigator.mediaDevices.enumerateDevices().then((devices) => {

      devices.forEach(device => {

        if (device.kind == 'videoinput') {
          this.availableDevices.push(device.deviceId);
        }

      });

    });

  }

  public ngAfterViewInit() {

    let videoPlayer = this.videoPlayer.nativeElement;

    fromEvent(videoPlayer, 'loadeddata').subscribe(() => {

      if (videoPlayer.videoHeight > videoPlayer.videoWidth) {
        videoPlayer.setAttribute('width', "370px");
        videoPlayer.setAttribute('height', null);
        videoPlayer.play();
      } else {
        // videoPlayer.setAttribute('height', "370px");
        videoPlayer.setAttribute('width', null);
        videoPlayer.play();
      }

    });

    this.toggleCamera();

  }

  toggleCamera() {

    // navigator.mediaDevices.getUserMedia({ video: { facingMode: "user" } })
    // .then((stream) => {
    //   this.videoPlayer.nativeElement.srcObject = stream;
    //   this.videoPlayer.nativeElement.play();
    //   this.currentStream = stream;
    // })
    // .catch((err) => {
    //   alert("Camera init error! " + err);
    // });

    this.videoPlayer.nativeElement.pause();
    this.currentDevice = this.currentDevice >= this.availableDevices.length - 1 ? 0 : this.currentDevice + 1;

    if(this.currentStream){
      this.currentStream.getTracks().forEach((track) => { track.stop(); });
    }

    let constraints = {
      video: {
        width:1280,
        height: 1280,
        // width:640,
        // height: 640,
        deviceId: this.availableDevices[this.currentDevice] ? {exact: this.availableDevices[this.currentDevice]} : undefined
      },
      audio: false
    };

    navigator.mediaDevices.getUserMedia(constraints)
    .then((stream) => {
      this.videoPlayer.nativeElement.srcObject = stream;
      this.videoPlayer.nativeElement.play();
      this.currentStream = stream;
      this.loading = false;
      this.cameraErrorEvent.emit(false);
    })
    .catch((err) => {
      this.cameraError = true;
      this.cameraErrorEvent.emit(true);
    });

  }

  getDimensions(width, height) {

    if (width > height) {

      let temp = width - height;
      let start = (temp / 2);

      let sx = start;
      let sy = 0;
      let sw = height;
      let sh = height;

      return [sx, sy, sw, sh];

    }

    if (height > width) {

      let temp = height - width;
      let start = (temp / 2);

      let sx = 0;
      let sy = start;
      let sw = width;
      let sh = width;

      return [sx, sy, sw, sh];

    }

    return [0, 0, width, height];

  }

  takeSnapshot() {
    let canvas = document.createElement("canvas");
    var context = canvas.getContext('2d');
    


    canvas.width = canvas.height = this.videoPlayer.nativeElement.videoWidth;

    let squareDimensions = this.getDimensions(this.videoPlayer.nativeElement.videoWidth, this.videoPlayer.nativeElement.videoHeight);
    

    context.drawImage(this.videoPlayer.nativeElement,
      squareDimensions[0], squareDimensions[1], squareDimensions[2], squareDimensions[3],
      0, 0, canvas.width, canvas.height);

    var data = canvas.toDataURL('image/png');
    this.outputImage.nativeElement.setAttribute('src', data);

    this.expandImage();
    this.snapshotEvent.emit(data);

  }

  expandImage() {

    if (this.imageHeight == 250) {
      this.imageHeight = 250;
      this.adjustImageHeight = false;
      return;
    }

    this.imageHeight += 2;

    if (this.imageHeight <= 250) {

      setTimeout(() => {
        this.expandImage();
      }, 2.5);

    }

  }



  shrinkImage() {
    this.adjustImageHeight = true;
    if (this.imageHeight <= 0) {
      this.imageHeight = 0;
      return;
    }

    this.imageHeight -= 2;

    if (this.imageHeight > 0) {
      setTimeout(() => {
        this.shrinkImage();
      }, 2.5);

    }

  }

}
